var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from "lit";
import { customElement, property } from "lit/decorators.js";
import { localized, msg } from "@lit/localize";
import "../icon/Icon.js";
let RightModalForm = class RightModalForm extends LitElement {
    constructor() {
        super(...arguments);
        this.title = "";
        this.open = false;
        this.overlay = false;
        this.width = "550px";
        this.handleKeydown = (e) => {
            if (e.key === "Escape" && this.open) {
                this.handleClose();
            }
        };
        this.handleOverlayClick = () => {
            this.handleClose();
        };
    }
    connectedCallback() {
        super.connectedCallback();
        document.addEventListener("keydown", this.handleKeydown);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        document.removeEventListener("keydown", this.handleKeydown);
    }
    handleClose() {
        this.open = false;
        this.dispatchEvent(new CustomEvent("close", {
            bubbles: true,
            composed: true
        }));
    }
    render() {
        return html `
      <div class="overlay" @click=${this.handleOverlayClick}></div>
      <div class="panel" style="--rmf-width: ${this.width}">
        <div class="header">
          <h3 class="title">${this.title || msg('Form', { id: 'rightModalForm.defaultTitle', desc: 'Default title for the right modal form panel' })}</h3>
          <button
            class="close-btn"
            type="button"
            aria-label=${msg('Close', { id: 'rightModalForm.close', desc: 'Accessible label for the close button' })}
            @click=${this.handleClose}
          >
            <basic-icon name="close" size="18"></basic-icon>
          </button>
        </div>
        <div class="content">
          <slot></slot>
        </div>
        <div class="footer">
          <slot name="footer"></slot>
        </div>
      </div>
    `;
    }
};
RightModalForm.styles = css `
  :host {
    --rmf-width: 550px;
  }
  .overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.3);
    z-index: 999;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.3s ease;
  }
  :host([open][overlay]) .overlay {
    opacity: 1;
    pointer-events: auto;
  }
  .panel {
    position: fixed;
    top: 0;
    right: 0;
    width: var(--rmf-width);
    max-width: 90vw;
    height: 100%;
    background: white;
    box-shadow: -6px 0 16px rgba(0, 0, 0, 0.1);
    transform: translateX(100%);
    transition: transform 0.3s ease;
    z-index: 1000;
    display: flex;
    flex-direction: column;
  }
  :host([open]) .panel {
    transform: translateX(0);
  }
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 20px;
    border-bottom: 1px solid #eee;
    flex-shrink: 0;
  }
  .title {
    margin: 0;
    font-size: 1.25rem;
    font-weight: 700;
    color: #1b96ff;
  }
  .close-btn {
    width: 32px;
    height: 32px;
    border: none;
    background: transparent;
    border-radius: 8px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #999;
    transition: background 0.2s, color 0.2s;
    padding: 0;
  }
  .close-btn:hover {
    background: #f0f0f0;
    color: #333;
  }
  .close-btn svg {
    display: block;
  }
  .content {
    flex: 1;
    overflow-y: auto;
    padding: 24px;
  }
  .footer {
    flex-shrink: 0;
    border-top: 1px solid #eee;
    padding: 16px 20px;
    display: flex;
    justify-content: flex-end;
    gap: 8px;
  }
  .footer:empty {
    display: none;
  }
  `;
__decorate([
    property({ type: String })
], RightModalForm.prototype, "title", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], RightModalForm.prototype, "open", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], RightModalForm.prototype, "overlay", void 0);
__decorate([
    property({ type: String })
], RightModalForm.prototype, "width", void 0);
RightModalForm = __decorate([
    localized(),
    customElement("right-modal-form")
], RightModalForm);
export { RightModalForm };
//# sourceMappingURL=RightModalForm.js.map